import React from 'react';
import { useParams } from 'react-router-dom';
import { DealRouteGuard } from '@/components/layouts/RecordRouteGuard/DealRouteGuard';
import DealViewWrapper from '@/components/views/DealView/DealViewWrapper';
import { Box } from '@mui/material';

const ViewDealPage = () => {
	const { dealId } = useParams();

	// Keyed so switching deals (e.g. via global search) remounts the view instead of showing the old deal's data.
	return (
		<DealRouteGuard>
			<Box pb={3}>
				<DealViewWrapper key={dealId} />
			</Box>
		</DealRouteGuard>
	);
};

export default ViewDealPage;
